<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3,5C3,5,13,5,13,5C13.5523,5,14,5.447715,14,6C14,6.55228,13.5523,7,13,7C13,7,3,7,3,7C2.447715,7,2,6.55228,2,6C2,5.447715,2.447715,5,3,5C3,5,3,5,3,5ZM3,9C3,9,13,9,13,9C13.5523,9,14,9.44772,14,10C14,10.55228,13.5523,11,13,11C13,11,3,11,3,11C2.447715,11,2,10.55228,2,10C2,9.44772,2.447715,9,3,9C3,9,3,9,3,9Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Equals',
} as DefineComponent
</script>
